/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Credit_NoneInputs */



/**
* | output |
* | --- |
* | "No designer credit" |
*
* @param {Deck_Credit_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_credit_none = /** @type {((inputs?: Deck_Credit_NoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Credit_NoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun crédit de conception")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin crédito de diseño")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem crédito de criação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun credito di creazione")
	return /** @type {LocalizedString} */ ("No designer credit")
});